/**
 * USIPIC Design Your Own — Shopify commerce bridge (price matrix + cart)
 */
(function () {
  'use strict';

  var CART_FILE_PROPERTY_KEYS = {
    'Original image': 'usipic-original.jpg',
    'Design cropped': 'usipic-cropped.jpg',
    'Customer preview': 'usipic-preview.png',
    'Design preview': 'usipic-design.png',
  };
  var CART_PROPERTY_MAX_LEN = 250;
  var CART_IMAGE_MAX_SIDE = { preview: 900 };

  var _boot = null;
  var _priceMatrix = null;
  var _priceMatrixPromise = null;
  var _ipicVariantsCache = null;
  var _defaultCartVariant = null;

  function readBootstrap() {
    if (_boot) return _boot;
    var el = document.getElementById('UsipicCustomizerBootstrap');
    if (!el) return {};
    try {
      _boot = JSON.parse(el.textContent || '{}');
    } catch (e) {
      _boot = {};
    }
    return _boot;
  }

  function readLiquidIpicVariants() {
    var el = document.getElementById('UsipicIpicVariants');
    if (!el) return null;
    try {
      var list = JSON.parse(el.textContent || '[]');
      return Array.isArray(list) ? list : null;
    } catch (e) {
      return null;
    }
  }

  function getMoneyFormat() {
    var boot = readBootstrap();
    if (boot.moneyFormat) return boot.moneyFormat;
    if (window.T4Sconfigs && window.T4Sconfigs.moneyFormat) return window.T4Sconfigs.moneyFormat;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    return '${{amount}}';
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(cents) || cents == null) return '0';
    var amount = (Number(cents) / 100).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] != null && precision > 0 ? dollars + decimal + parts[1] : dollars;
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(re);
    if (!match) return '$' + formatWithDelimiters(cents, 2);
    var token = match[1];
    var value;
    if (token === 'amount') value = formatWithDelimiters(cents, 2);
    else if (token === 'amount_no_decimals') value = formatWithDelimiters(cents, 0);
    else if (token === 'amount_with_comma_separator') value = formatWithDelimiters(cents, 2, '.', ',');
    else value = formatWithDelimiters(cents, 2);
    return format.replace(re, value);
  }

  function normSize(s) {
    var p = String(s || '').replace(/\s+/g, '').toLowerCase().split('x');
    if (p.length !== 2) return String(s || '').replace(/\s+/g, '').toLowerCase();
    var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
    if (isNaN(a) || isNaN(b)) return String(s || '').replace(/\s+/g, '').toLowerCase();
    return (a <= b ? a : b) + 'x' + (a <= b ? b : a);
  }

  function sizeMatchKeys(size) {
    var p = String(size || '').replace(/\s+/g, '').toLowerCase().split('x');
    if (p.length !== 2) return [normSize(size)];
    var w = parseInt(p[0], 10), h = parseInt(p[1], 10);
    if (isNaN(w) || isNaN(h)) return [normSize(size)];
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var keys = {};
    keys[normSize(size)] = true;
    keys[w + 'x' + h] = true;
    keys[h + 'x' + w] = true;
    keys[w + 'x' + pad(h)] = true;
    keys[pad(w) + 'x' + pad(h)] = true;
    keys[h + 'x' + pad(w)] = true;
    keys[pad(h) + 'x' + pad(w)] = true;
    keys[pad(w) + 'x' + h] = true;
    return Object.keys(keys);
  }

  function loadPriceMatrix() {
    if (_priceMatrix) return Promise.resolve(_priceMatrix);
    if (_priceMatrixPromise) return _priceMatrixPromise;
    var boot = readBootstrap();
    var url = boot.priceMatrixUrl;
    if (!url) {
      _priceMatrix = { baseModel: 'C25', prices: {} };
      return Promise.resolve(_priceMatrix);
    }
    _priceMatrixPromise = fetch(url, { credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('price matrix HTTP ' + r.status);
        return r.json();
      })
      .then(function (json) {
        _priceMatrix = json || { baseModel: 'C25', prices: {} };
        return _priceMatrix;
      })
      .catch(function () {
        _priceMatrix = { baseModel: 'C25', prices: {} };
        return _priceMatrix;
      });
    return _priceMatrixPromise;
  }

  function getMatrixRow(size) {
    if (!_priceMatrix || !_priceMatrix.prices) return null;
    var keys = sizeMatchKeys(size);
    for (var i = 0; i < keys.length; i++) {
      if (_priceMatrix.prices[keys[i]]) return _priceMatrix.prices[keys[i]];
    }
    return null;
  }

  function getMatrixEntry(size, model) {
    var row = getMatrixRow(size);
    if (!row || !model) return null;
    return row[String(model).toUpperCase()] || row[model] || null;
  }

  function matrixTotalCents(size, model) {
    var entry = getMatrixEntry(size, model);
    if (!entry || entry.total == null) return null;
    return Math.round(Number(entry.total) * 100);
  }

  function configToModel(config) {
    config = config || {};
    if (config.printType === 'framed' || config.printType === 'frame') {
      return String(config.frameCode || 'F97').toUpperCase();
    }
    var wrap = String(config.wrapCode || 'C25').toUpperCase();
    return wrap === 'C75' ? 'C75' : 'C25';
  }

  function buildConfiguratorSku(config) {
    config = config || {};
    var model = configToModel(config);
    var size = config.sizeId || '10x8';
    if (!_priceMatrix || !_priceMatrix.prices) return '';
    var keys = sizeMatchKeys(size);
    var canon = '';
    for (var i = 0; i < keys.length; i++) {
      if (_priceMatrix.prices[keys[i]]) {
        canon = keys[i];
        break;
      }
    }
    if (!canon) return '';
    var cp = canon.split('x');
    if (cp.length !== 2) return '';
    var sw = parseInt(cp[0], 10);
    var sh = parseInt(cp[1], 10);
    if (isNaN(sw) || isNaN(sh)) return '';
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    return 'CP0000' + model + pad(sw) + pad(sh);
  }

  function clampCartPropertyValue(val) {
    var s = val == null ? '' : String(val).trim();
    if (s.length <= CART_PROPERTY_MAX_LEN) return s;
    return s.slice(0, CART_PROPERTY_MAX_LEN - 1) + '\u2026';
  }

  function buildPlacementData(config) {
    config = config || {};
    var adj = config.stageAdjustment || {};
    var data = {
      sceneId: config.sceneId || '',
      offsetX: typeof adj.offsetX === 'number' ? adj.offsetX : 0,
      offsetY: typeof adj.offsetY === 'number' ? adj.offsetY : 0,
      scale: typeof adj.scale === 'number' ? adj.scale : 1,
      panX: typeof adj.panX === 'number' ? adj.panX : 50,
      panY: typeof adj.panY === 'number' ? adj.panY : 50,
      sizeId: config.sizeId || '',
      printType: config.printType || '',
      frameCode: config.frameCode || '',
      wrapCode: config.wrapCode || '',
    };
    if (config.artBounds && config.artBounds.w > 0) {
      data.artBounds = {
        x: Math.round(config.artBounds.x),
        y: Math.round(config.artBounds.y),
        w: Math.round(config.artBounds.w),
        h: Math.round(config.artBounds.h),
      };
    }
    return data;
  }

  function formatPlacementVisible(placement) {
    if (!placement) return '';
    var parts = [
      'Scene ' + (placement.sceneId || '—'),
      'Offset X ' + placement.offsetX,
      'Y ' + placement.offsetY,
      'Scale ' + placement.scale,
      'Pan X ' + placement.panX,
      'Y ' + placement.panY,
    ];
    if (placement.artBounds) {
      parts.push(
        'Bounds ' +
          placement.artBounds.x +
          ',' +
          placement.artBounds.y +
          ',' +
          placement.artBounds.w +
          ',' +
          placement.artBounds.h
      );
    }
    return parts.join(' | ');
  }

  function buildCartProperties(config, unitCents) {
    config = config || {};
    var props = {};
    function setProp(key, val) {
      var s = clampCartPropertyValue(val);
      if (s) props[key] = s;
    }
    var configSku = buildConfiguratorSku(config);
    var model = configToModel(config);
    if (configSku) {
      setProp('_configurator_sku', configSku);
      setProp('Configurator SKU', configSku);
      setProp('SKU', configSku);
    }
    if (unitCents > 0) {
      setProp('Configured price', formatMoney(unitCents));
      setProp('_configured_price_cents', String(unitCents));
    }
    setProp('Size', config.sizeLabel || config.sizeId);
    setProp('Print Type', config.printType === 'framed' || config.printType === 'frame' ? 'Framed Print' : 'Canvas Print');
    setProp('Model Code', model);
    if (config.printType === 'framed' || config.printType === 'frame') {
      setProp('Frame Type', config.frameName || config.frameCode || model);
    } else {
      setProp('Wrap Type', config.wrapName || (model === 'C75' ? 'Museum Wrap' : 'Gallery Wrap'));
    }
    if (config.note) setProp('Note', config.note);
    if (config.originalImageFile) {
      setProp('Original filename', config.originalImageFile.name);
      setProp('_original_bytes', String(config.originalImageFile.size));
    }
    if (config.textLayers && config.textLayers.length) {
      setProp('Text Layers', String(config.textLayers.length));
    }
    var placement = buildPlacementData(config);
    if (placement.sceneId || config.stageAdjustment) {
      setProp('_placement_data', JSON.stringify(placement));
      setProp('Placement coordinates', formatPlacementVisible(placement));
    }
    if (placement.artBounds) {
      setProp(
        'Art bounds (px)',
        placement.artBounds.x +
          ',' +
          placement.artBounds.y +
          ',' +
          placement.artBounds.w +
          ',' +
          placement.artBounds.h
      );
    }
    return props;
  }

  /** Find the pre-priced variant (size x model) from the shared I'PIC matrix. */
  function findVariantBySku(variants, sku) {
    if (!sku || !variants) return null;
    var want = String(sku).toUpperCase();
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].sku || '').toUpperCase() === want) return variants[i];
    }
    return null;
  }

  function normalizeVariantList(variants) {
    return (variants || []).map(function (v) {
      return {
        id: v.id,
        sku: v.sku,
        price: v.price,
        priceCents: v.price != null ? Math.round(Number(v.price)) : null,
        option1: v.option1,
        option2: v.option2,
        available: v.available !== false,
      };
    });
  }

  function fetchIpicVariants() {
    if (_ipicVariantsCache) return Promise.resolve(_ipicVariantsCache);
    var liquid = readLiquidIpicVariants();
    if (liquid && liquid.length) {
      _ipicVariantsCache = normalizeVariantList(liquid);
      return Promise.resolve(_ipicVariantsCache);
    }
    var boot = readBootstrap();
    var handle = boot.ipicProductHandle;
    if (!handle) return Promise.reject(new Error('Missing I\'PIC product handle'));
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        _ipicVariantsCache = normalizeVariantList(data.variants || []);
        return _ipicVariantsCache;
      });
  }

  function resolveDefaultCartVariant(variants) {
    if (_defaultCartVariant && _defaultCartVariant.id) return _defaultCartVariant;
    if (!variants || !variants.length) return null;
    var boot = readBootstrap();
    var bootId = boot.defaultCartVariantId != null ? Number(boot.defaultCartVariantId) : 0;
    if (bootId > 0) {
      for (var i = 0; i < variants.length; i++) {
        if (Number(variants[i].id) === bootId) {
          _defaultCartVariant = variants[i];
          return _defaultCartVariant;
        }
      }
    }
    if (variants.length === 1) {
      _defaultCartVariant = variants[0];
      return _defaultCartVariant;
    }
    _defaultCartVariant = variants[0];
    return _defaultCartVariant;
  }

  function cartAddUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'cart/add.js';
  }

  function canvasToJpegBlob(canvas, quality) {
    return new Promise(function (resolve) {
      if (!canvas || !canvas.width) return resolve(null);
      try {
        canvas.toBlob(function (blob) { resolve(blob || null); }, 'image/jpeg', quality != null ? quality : 0.88);
      } catch (e) {
        resolve(null);
      }
    });
  }

  function downscaleCanvas(srcCanvas, maxSide) {
    if (!srcCanvas || !srcCanvas.width || !maxSide) return srcCanvas;
    var w = srcCanvas.width;
    var h = srcCanvas.height;
    var scale = Math.min(1, maxSide / Math.max(w, h));
    if (scale >= 1) return srcCanvas;
    var out = document.createElement('canvas');
    out.width = Math.max(1, Math.round(w * scale));
    out.height = Math.max(1, Math.round(h * scale));
    var ctx = out.getContext('2d');
    if (ctx) ctx.drawImage(srcCanvas, 0, 0, out.width, out.height);
    return out;
  }

  function loadImageFromSource(source) {
    return new Promise(function (resolve) {
      if (!source) return resolve(null);
      if (source instanceof HTMLImageElement && source.naturalWidth) return resolve(source);
      if (source instanceof HTMLCanvasElement && source.width) return resolve(source);
      if (source instanceof Blob) {
        var url = URL.createObjectURL(source);
        var img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          resolve(img);
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          resolve(null);
        };
        img.src = url;
        return;
      }
      if (typeof source === 'string') {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () { resolve(im); };
        im.onerror = function () { resolve(null); };
        im.src = source;
        return;
      }
      resolve(null);
    });
  }

  function compressImageSource(source, maxSide, quality) {
    return loadImageFromSource(source).then(function (img) {
      if (!img) return null;
      var w = img.naturalWidth || img.width || 1;
      var h = img.naturalHeight || img.height || 1;
      var scale = Math.min(1, maxSide / Math.max(w, h));
      var cw = Math.max(1, Math.round(w * scale));
      var ch = Math.max(1, Math.round(h * scale));
      var c = document.createElement('canvas');
      c.width = cw;
      c.height = ch;
      c.getContext('2d').drawImage(img, 0, 0, cw, ch);
      return canvasToJpegBlob(c, quality);
    });
  }

  function compressCanvasForCart(canvas, maxSide, quality) {
    var scaled = downscaleCanvas(canvas, maxSide);
    return canvasToJpegBlob(scaled, quality);
  }

  function originalFilenameFromMime(mime, fallbackName) {
    if (fallbackName && /\.(jpe?g|png|webp|gif)$/i.test(fallbackName)) {
      var ext = fallbackName.split('.').pop().toLowerCase();
      if (ext === 'jpeg') ext = 'jpg';
      return 'usipic-original.' + ext;
    }
    if (mime === 'image/png') return 'usipic-original.png';
    if (mime === 'image/webp') return 'usipic-original.webp';
    if (mime === 'image/gif') return 'usipic-original.gif';
    return 'usipic-original.jpg';
  }

  function canvasToPngBlob(canvas) {
    return new Promise(function (resolve) {
      if (!canvas || !canvas.width) return resolve(null);
      try {
        canvas.toBlob(function (blob) { resolve(blob || null); }, 'image/png');
      } catch (e) {
        resolve(null);
      }
    });
  }

  function prepareOriginalImageForCart(file) {
    if (!file) return Promise.resolve(null);
    return Promise.resolve({
      blob: file,
      filename: originalFilenameFromMime(file.type, file.name),
    });
  }

  function resolveCartFileEntry(entry, defaultFilename) {
    if (!entry) return null;
    if (entry instanceof Blob) return { blob: entry, filename: defaultFilename };
    if (entry.blob) return { blob: entry.blob, filename: entry.filename || defaultFilename };
    return null;
  }

  function postCartAdd(vid, quantity, properties, fileBlobs) {
    fileBlobs = fileBlobs || {};
    var hasFiles = Object.keys(fileBlobs).some(function (key) {
      return !!resolveCartFileEntry(fileBlobs[key], CART_FILE_PROPERTY_KEYS[key]);
    });
    if (hasFiles) {
      var fd = new FormData();
      fd.append('items[0][id]', String(vid));
      fd.append('items[0][quantity]', String(quantity));
      Object.keys(properties).forEach(function (key) {
        if (CART_FILE_PROPERTY_KEYS[key]) return;
        fd.append('items[0][properties][' + key + ']', properties[key]);
      });
      Object.keys(fileBlobs).forEach(function (key) {
        if (!CART_FILE_PROPERTY_KEYS[key]) return;
        var pack = resolveCartFileEntry(fileBlobs[key], CART_FILE_PROPERTY_KEYS[key]);
        if (pack && pack.blob) {
          fd.append('items[0][properties][' + key + ']', pack.blob, pack.filename);
        }
      });
      return fetch(cartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: fd,
      });
    }
    return fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: quantity, properties: properties }] }),
    });
  }

  function parseCartAddResponse(res) {
    return res.text().then(function (text) {
      var body = null;
      try {
        body = text ? JSON.parse(text) : null;
      } catch (e) {
        throw new Error('Cart error (' + res.status + ')');
      }
      if (!res.ok) {
        if (res.status === 413) {
          throw new Error('Upload too large — try a smaller image or lower resolution photo.');
        }
        throw new Error((body && (body.description || body.message)) || 'Cart error (' + res.status + ')');
      }
      return body;
    });
  }

  function getUnitPriceCents(config) {
    return matrixTotalCents(config.sizeId || '10x8', configToModel(config));
  }

  function getTotalPriceCents(config, qty) {
    var unit = getUnitPriceCents(config);
    if (unit == null) return null;
    qty = Math.max(1, Number(qty) || 1);
    return unit * qty;
  }

  function formatAddon(size, model) {
    var entry = getMatrixEntry(size, model);
    var base = getMatrixEntry(size, (_priceMatrix && _priceMatrix.baseModel) || 'C25');
    if (!entry || !base || Number(entry.addon) <= 0) return '';
    return '+' + formatMoney(Math.round(Number(entry.addon) * 100));
  }

  function isOptionAvailable(size, model) {
    /* Before the matrix finishes loading we cannot judge availability; do not grey out. */
    if (!_priceMatrix || !_priceMatrix.prices) return true;
    var entry = getMatrixEntry(size, model);
    return !!(entry && entry.total != null);
  }

  function init() {
    readBootstrap();
    return loadPriceMatrix();
  }

  function exportDesignPreviewBlob(config) {
    return new Promise(function (resolve) {
      var renderer = window.__USIPIC_SCENE_RENDERER__;
      if (!renderer || !renderer.renderDesignPreviewForExport || !config.customImageDataUrl) {
        resolve(null);
        return;
      }
      var pan = config.stageAdjustment
        ? { x: config.stageAdjustment.panX, y: config.stageAdjustment.panY }
        : { x: 50, y: 50 };
      renderer.renderDesignPreviewForExport(
        {
          artworkSource: config.customImageDataUrl,
          size: config.sizeId,
          printType: config.printType === 'framed' || config.printType === 'frame' ? 'frame' : 'canvas',
          frameCode: config.frameCode,
          wrapCode: config.wrapCode,
          artPan: pan,
          transparentBackground: true,
        },
        function (canvas) {
          if (!canvas) return resolve(null);
          var scaled = downscaleCanvas(canvas, CART_IMAGE_MAX_SIDE.preview);
          canvasToPngBlob(scaled).then(resolve);
        }
      );
    });
  }

  function collectCartDesignFiles(config) {
    var fileBlobs = {};

    var tasks = [];

    if (config.originalImageFile) {
      tasks.push(
        prepareOriginalImageForCart(config.originalImageFile).then(function (pack) {
          if (pack && pack.blob) fileBlobs['Original image'] = pack;
        })
      );
    } else if (config.customImageDataUrl) {
      tasks.push(
        fetch(config.customImageDataUrl)
          .then(function (r) { return r.blob(); })
          .then(function (b) {
            if (b) {
              fileBlobs['Original image'] = {
                blob: b,
                filename: originalFilenameFromMime(b.type),
              };
            }
          })
          .catch(function () { return null; })
      );
    }

    tasks.push(
      exportDesignPreviewBlob(config).then(function (b) {
        if (b) {
          fileBlobs['Design preview'] = {
            blob: b,
            filename: CART_FILE_PROPERTY_KEYS['Design preview'],
          };
        }
      })
    );

    return Promise.all(tasks).then(function () {
      return fileBlobs;
    });
  }

  function addToCart(config) {
    config = config || {};
    var qty = Math.max(1, Math.min(999, Number(config.quantity) || 1));
    return loadPriceMatrix()
      .then(function () {
        return fetchIpicVariants();
      })
      .then(function (variants) {
        /* This product only carries a base-price variant, so the cart line must use the
           matrix variant for the configured size + model, otherwise add-ons are not charged. */
        var configSku = buildConfiguratorSku(config);
        var variant = findVariantBySku(variants, configSku) || resolveDefaultCartVariant(variants);
        if (!variant || !variant.id) throw new Error('Cart variant not found' + (configSku ? ' for ' + configSku : '') + '.');
        var priced = getUnitPriceCents(config);
        if (priced == null || priced <= 0) {
          throw new Error('This size / frame combination is not available.');
        }
        var unitCents = priced;
        var properties = buildCartProperties(config, unitCents);
        return collectCartDesignFiles(config).then(function (fileBlobs) {
          return postCartAdd(variant.id, qty, properties, fileBlobs);
        });
      })
      .then(parseCartAddResponse)
      .then(function (body) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        try {
          window.dispatchEvent(new CustomEvent('new-usipic:open-cart'));
        } catch (e) {}
        return body;
      });
  }

  window.__USIPIC_DYO_COMMERCE__ = {
    init: init,
    formatMoney: formatMoney,
    loadPriceMatrix: loadPriceMatrix,
    getUnitPriceCents: getUnitPriceCents,
    getTotalPriceCents: getTotalPriceCents,
    buildConfiguratorSku: buildConfiguratorSku,
    configToModel: configToModel,
    isOptionAvailable: isOptionAvailable,
    formatAddon: formatAddon,
    getMatrixEntry: getMatrixEntry,
    addToCart: addToCart,
  };
})();
